var render = function render(){var _vm=this,_c=_vm._self._c;return _c('take-a-photo-template',{attrs:{"doctor-info":_vm.doctorInfo,"user-info":_vm.patientInfo,"language":_vm.locale,"language-options":_vm.languageOptions,"error":_vm.errorMessage},on:{"change-language":_vm.onChangeLanguage,"take-photo":_vm.onTakePhoto,"back":_vm.onBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }